import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./styles.module.css";

const Loading = ({ loadingClass }) => {
  const loadingClasses = classNames({
    [styles.spinner]: true,
    [loadingClass]: loadingClass,
  });

  return (
    <div className={styles.loading}>
      <div className={loadingClasses}></div>
    </div>
  );
};

Loading.propTypes = {
  loadingClass: PropTypes.string,
};

export default Loading;
